// extracted by mini-css-extract-plugin
module.exports = {"asosFocus":"_1k-ioLY","link":"_25irHcd _1k-ioLY"};